/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  background: var(--qds-theme-accessory-background);
  border-radius: var(--qds-accessory-border-radius);
  box-shadow: var(--qds-theme-accessory-elevation);
  box-sizing: border-box;
  display: inline-block;
  left: 0;
  top: 0;
}
